// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1hb-4","title":"AfterBackImages_title__OAdOf","images":"AfterBackImages_images__1bt_E"};